export const ADD_SIGNATURE = "ADD_SIGNATURE";
export const ADD_SIGNATURE_SUCCESS = "ADD_SIGNATURE_SUCCESS";
export const ADD_SIGNATURE_FAIL = "ADD_SIGNATURE_FAIL";

export const GET_SIGNATURE = "GET_SIGNATURE";
export const GET_SIGNATURE_SUCCESS = "GET_SIGNATURE_SUCCESS";
export const GET_SIGNATURE_FAIL = "GET_SIGNATURE_FAIL";

export const UPDATE_SIGNATURE = "UPDATE_SIGNATURE";
export const UPDATE_SIGNATURE_SUCCESS = "UPDATE_SIGNATURE_SUCCESS";
export const UPDATE_SIGNATURE_FAIL = "UPDATE_SIGNATURE_FAIL";

export const GET_SIGNATURE_BY_ID = "GET_SIGNATURE_BY_ID";
export const GET_SIGNATURE_BY_ID_SUCCESS = "GET_SIGNATURE_BY_ID_SUCCESS";
export const GET_SIGNATURE_BY_ID_FAIL = "GET_SIGNATURE_BY_ID_FAIL";

export const DELETE_SIGNATURE = "DELETE_SIGNATURE";
export const DELETE_SIGNATURE_SUCCESS = "DELETE_SIGNATURE_SUCCESS";
export const DELETE_SIGNATURE_FAIL = "DELETE_SIGNATURE_FAIL";

export const GET_MESSAGE_LIST = "GET_MESSAGE_LIST";
export const GET_MESSAGE_LIST_SUCCESS = "GET_MESSAGE_LIST_SUCCESS";
export const GET_MESSAGE_LIST_FAIL = "GET_MESSAGE_LIST_FAIL";

export const GET_MESSAGE_BY_ID = "GET_MESSAGE_BY_ID";
export const GET_MESSAGE_BY_ID_SUCCESS = "GET_MESSAGE_BY_ID_SUCCESS";
export const GET_MESSAGE_BY_ID_FAIL = "GET_MESSAGE_BY_ID_FAIL";

export const GET_SUBSCRIBER_LIST = "GET_SUBSCRIBER_LIST";
export const GET_SUBSCRIBER_LIST_SUCCESS = "GET_SUBSCRIBER_LIST_SUCCESS";
export const GET_SUBSCRIBER_LIST_FAIL = "GET_SUBSCRIBER_LIST_FAIL";

export const GET_SUBSCRIBER_BY_ID = "GET_SUBSCRIBER_BY_ID";
export const GET_SUBSCRIBER_BY_ID_SUCCESS = "GET_SUBSCRIBER_BY_ID_SUCCESS";
export const GET_SUBSCRIBER_BY_ID_FAIL = "GET_SUBSCRIBER_BY_ID_FAIL";

export const GET_FACEBOOK_LIST = "GET_FACEBOOK_LIST";
export const GET_FACEBOOK_LIST_SUCCESS = "GET_FACEBOOK_LIST_SUCCESS";
export const GET_FACEBOOK_LIST_FAIL = "GET_FACEBOOK_LIST_FAIL";

export const GET_FACEBOOK_BY_ID = "GET_FACEBOOK_BY_ID";
export const GET_FACEBOOK_BY_ID_SUCCESS = "GET_FACEBOOK_BY_ID_SUCCESS";
export const GET_FACEBOOK_BY_ID_FAIL = "GET_FACEBOOK_BY_ID_FAIL";

export const GET_INSTAGRAM_LIST = "GET_INSTAGRAM_LIST";
export const GET_INSTAGRAM_LIST_SUCCESS = "GET_INSTAGRAM_LIST_SUCCESS";
export const GET_INSTAGRAM_LIST_FAIL = "GET_INSTAGRAM_LIST_FAIL";

export const GET_INSTAGRAM_BY_ID = "GET_INSTAGRAM_BY_ID";
export const GET_INSTAGRAM_BY_ID_SUCCESS = "GET_INSTAGRAM_BY_ID_SUCCESS";
export const GET_INSTAGRAM_BY_ID_FAIL = "GET_INSTAGRAM_BY_ID_FAIL";

export const GET_TWITTER_LIST = "GET_TWITTER_LIST";
export const GET_TWITTER_LIST_SUCCESS = "GET_TWITTER_LIST_SUCCESS";
export const GET_TWITTER_LIST_FAIL = "GET_TWITTER_LIST_FAIL";

export const GET_TWITTER_BY_ID = "GET_TWITTER_BY_ID";
export const GET_TWITTER_BY_ID_SUCCESS = "GET_TWITTER_BY_ID_SUCCESS";
export const GET_TWITTER_BY_ID_FAIL = "GET_TWITTER_BY_ID_FAIL";

export const GET_YOUTUBE_LIST = "GET_YOUTUBE_LIST";
export const GET_YOUTUBE_LIST_SUCCESS = "GET_YOUTUBE_LIST_SUCCESS";
export const GET_YOUTUBE_LIST_FAIL = "GET_YOUTUBE_LIST_FAIL";

export const GET_YOUTUBE_BY_ID = "GET_YOUTUBE_BY_ID";
export const GET_YOUTUBE_BY_ID_SUCCESS = "GET_YOUTUBE_BY_ID_SUCCESS";
export const GET_YOUTUBE_BY_ID_FAIL = "GET_YOUTUBE_BY_ID_FAIL";

export const GET_TIKTOK_LIST = "GET_TIKTOK_LIST";
export const GET_TIKTOK_LIST_SUCCESS = "GET_TIKTOK_LIST_SUCCESS";
export const GET_TIKTOK_LIST_FAIL = "GET_TIKTOK_LIST_FAIL";

export const GET_TIKTOK_BY_ID = "GET_TIKTOK_BY_ID";
export const GET_TIKTOK_BY_ID_SUCCESS = "GET_TIKTOK_BY_ID_SUCCESS";
export const GET_TIKTOK_BY_ID_FAIL = "GET_TIKTOK_BY_ID_FAIL";

// =================== DETAIL SETTINGS ===================== //

export const GET_DETAIL_SETTINGS = "GET_DETAIL_SETTINGS";
export const GET_DETAIL_SETTINGS_SUCCESS = "GET_DETAIL_SETTINGS_SUCCESS";
export const GET_DETAIL_SETTINGS_FAIL = "GET_DETAIL_SETTINGS_FAIL";

export const UPDATE_DETAIL_SETTING = "UPDATE_DETAIL_SETTING";
export const UPDATE_DETAIL_SETTING_SUCCESS = "UPDATE_DETAIL_SETTING_SUCCESS";
export const UPDATE_DETAIL_SETTING_FAIL = "UPDATE_DETAIL_SETTING_FAIL";

export const GET_FORM_LIST = "GET_FORM_LIST";
export const GET_FORM_LIST_SUCCESS = "GET_FORM_LIST_SUCCESS";
export const GET_FORM_LIST_FAIL = "GET_FORM_LIST_FAIL";

export const GET_FORM_BY_ID = "GET_FORM_BY_ID";
export const GET_FORM_BY_ID_SUCCESS = "GET_FORM_BY_ID_SUCCESS";
export const GET_FORM_BY_ID_FAIL = "GET_FORM_BY_ID_FAIL";

export const GET_FINANCE_LIST = "GET_FINANCE_LIST";
export const GET_FINANCE_LIST_SUCCESS = "GET_FINANCE_LIST_SUCCESS";
export const GET_FINANCE_LIST_FAIL = "GET_FINANCE_LIST_FAIL";

export const GET_FINANCE_BY_ID = "GET_FINANCE_BY_ID";
export const GET_FINANCE_BY_ID_SUCCESS = "GET_FINANCE_BY_ID_SUCCESS";
export const GET_FINANCE_BY_ID_FAIL = "GET_FINANCE_BY_ID_FAIL";

export const POST_FINANCIAL = "POST_FINANCIAL";
export const POST_FINANCIAL_SUCCESS = "POST_FINANCIAL_SUCCESS";
export const POST_FINANCIAL_FAIL = "POST_FINANCIAL_FAIL";

// ===========

export const POST_SUBADMIN = "POST_SUBADMIN";
export const POST_SUBADMIN_SUCCESS = "POST_SUBADMIN_SUCCESS";
export const POST_SUBADMIN_FAIL = "POST_SUBADMIN_FAIL";

export const GET_SUBADMIN_LIST = "GET_SUBADMIN_LIST";
export const GET_SUBADMIN_LIST_SUCCESS = "GET_SUBADMIN_LIST_SUCCESS";
export const GET_SUBADMIN_LIST_FAIL = "GET_SUBADMIN_LIST_FAIL";

export const GET_SUBADMIN_BY_ID = "GET_SUBADMIN_BY_ID";
export const GET_SUBADMIN_BY_ID_SUCCESS = "GET_SUBADMIN_BY_ID_SUCCESS";
export const GET_SUBADMIN_BY_ID_FAIL = "GET_SUBADMIN_BY_ID_FAIL";

export const UPDATE_SUBADMIN = "UPDATE_SUBADMIN";
export const UPDATE_SUBADMIN_SUCCESS = "UPDATE_SUBADMIN_SUCCESS";
export const UPDATE_SUBADMIN_FAIL = "UPDATE_SUBADMIN_FAIL";

export const DELETE_SUBADMIN = "DELETE_SUBADMIN";
export const DELETE_SUBADMIN_SUCCESS = "DELETE_SUBADMIN_SUCCESS";
export const DELETE_SUBADMIN_FAIL = "DELETE_SUBADMIN_FAIL";

export const RESET_SUBADMIN_PASS = "RESET_SUBADMIN_PASS";
export const RESET_SUBADMIN_PASS_SUCCESS = "RESET_SUBADMIN_PASS_SUCCESS";
export const RESET_SUBADMIN_PASS_FAIL = "RESET_SUBADMIN_PASS_FAIL";

export const DROPDOWN_SUBADMIN = "DROPDOWN_SUBADMIN";
export const DROPDOWN_SUBADMIN_SUCCESS = "DROPDOWN_SUBADMIN_SUCCESS";
export const DROPDOWN_SUBADMIN_FAIL = "DROPDOWN_SUBADMIN_FAIL";

// ============= ROLE ================== //

export const POST_ROLE = "POST_ROLE";
export const POST_ROLE_SUCCESS = "POST_ROLE_SUCCESS";
export const POST_ROLE_FAIL = "POST_ROLE_FAIL";

export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const GET_ROLE_LIST_SUCCESS = "GET_ROLE_LIST_SUCCESS";
export const GET_ROLE_LIST_FAIL = "GET_ROLE_LIST_FAIL";

export const GET_ROLE_BY_ID = "GET_ROLE_BY_ID";
export const GET_ROLE_BY_ID_SUCCESS = "GET_ROLE_BY_ID_SUCCESS";
export const GET_ROLE_BY_ID_FAIL = "GET_ROLE_BY_ID_FAIL";

export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAIL = "UPDATE_ROLE_FAIL";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAIL = "DELETE_ROLE_FAIL";

export const ADMIN_DETAIL = "ADMIN_DETAIL";
export const ADMIN_DETAIL_SUCCESS = "ADMIN_DETAIL_SUCCESS";
export const ADMIN_DETAIL_FAIL = "ADMIN_DETAIL_FAIL";

export const ROW_SORTING = "ROW_SORTING";
export const ROW_SORTING_SUCCESS = "ROW_SORTING_SUCCESS";
export const ROW_SORTING_FAIL = "ROW_SORTING_FAIL";

export const POST_CONFIGURE = "POST_CONFIGURE";
export const POST_CONFIGURE_SUCCESS = "POST_CONFIGURE_SUCCESS";
export const POST_CONFIGURE_FAIL = "POST_CONFIGURE_FAIL";

export const GET_CONFIGURE = "GET_CONFIGURE";
export const GET_CONFIGURE_SUCCESS = "GET_CONFIGURE_SUCCESS";
export const GET_CONFIGURE_FAIL = "GET_CONFIGURE_FAIL";

export const GET_FIELD_DATA = "GET_FIELD_DATA";
export const GET_FIELD_DATA_SUCCESS = "GET_FIELD_DATA_SUCCESS";
export const GET_FIELD_DATA_FAIL = "GET_FIELD_DATA_FAIL";

// ================ SEND EMAIL/SMS SUBSCRIBER ============ //

export const SEND_EMAIL_SUBSCRIBER = "SEND_EMAIL_SUBSCRIBER";
export const SEND_EMAIL_SUBSCRIBER_SUCCESS = "SEND_EMAIL_SUBSCRIBER_SUCCESS";
export const SEND_EMAIL_SUBSCRIBER_FAIL = "SEND_EMAIL_SUBSCRIBER_FAIL";

export const SEND_SMS_SUBSCRIBER = "SEND_SMS_SUBSCRIBER";
export const SEND_SMS_SUBSCRIBER_SUCCESS = "SEND_SMS_SUBSCRIBER_SUCCESS";
export const SEND_SMS_SUBSCRIBER_FAIL = "SEND_SMS_SUBSCRIBER_FAIL";

export const HEALTH_INSURANCE_LIST = "HEALTH_INSURANCE_LIST";
export const HEALTH_INSURANCE_LIST_SUCCESS = "HEALTH_INSURANCE_LIST_SUCCESS";
export const HEALTH_INSURANCE_LIST_FAIL = "HEALTH_INSURANCE_LIST_FAIL";

export const GET_HEALTH_INSURANCE = "GET_HEALTH_INSURANCE";
export const GET_HEALTH_INSURANCE_SUCCESS = "GET_HEALTH_INSURANCE_SUCCESS";
export const GET_HEALTH_INSURANCE_FAIL = "GET_HEALTH_INSURANCE_FAIL";

export const CONVERT_TO_IRS = "CONVERT_TO_IRS";
export const CONVERT_TO_IRS_SUCCESS = "CONVERT_TO_IRS_SUCCESS";
export const CONVERT_TO_IRS_FAIL = "CONVERT_TO_IRS_FAIL";
